import React from "react";
import Logo from "./Logo";
import heroImage from "../images/giardino_night.JPG";
import giardino_notte from "../images/giardino_notte.jpg";
import divano from "../images/sala_2_divani.jpg";
import giardino_2 from "../images/giardino_2.jpg";

export default function IlGiardino() {
  return (
    <div className="bg-white text-black">
      <Logo />

      {/* Main content area with consistent margin */}
      <div className="m-[100px]">
        {/* Hero Section */}
        <div className="relative w-full h-[60vh]">
          <img
            src={heroImage}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <h1 className="text-white text-5xl font-extrabold">IL GIARDINO</h1>
          </div>
        </div>
        <br></br>
        <div className="relative w-full h-[100vh]">
          <img
            src={giardino_notte}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Concept Section */}
        <section className="flex flex-col md:flex-row items-center gap-8 mt-16">
          <img
            src={giardino_2}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />
          <img
            src={giardino_2}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />
        </section>
      </div>
    </div>
  );
}
